import { render, staticRenderFns } from "./SurveyItem.vue?vue&type=template&id=cd637516&scoped=true"
import script from "./SurveyItem.vue?vue&type=script&lang=js"
export * from "./SurveyItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd637516",
  null
  
)

export default component.exports